<template>
  <div>
    <div id="map"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import "@/assets/js/leaflet-Mask";
import "@/assets/js/leaflet.ChineseTmsProviders";

export default {
  data() {
    return {
      baseMap: {},
    };
  },
  computed: {
    ...mapGetters({
      mapSwitch: "switchMap/mapSwitch",
      ip: "ip",
    }),
  },
  methods: {
    ...mapActions({
      initDarwMapData: "drawMap/initMapDataAction",
      initMeteorologicalMapData: "meteorologicalMap/initMapDataAction",
      initplanreleMapData: "planrele/initMapDataAction",
    }),
    ...mapMutations({
      changeMapSwitch: "switchMap/changeMapSwitch",
    }),
    getlo(item) {
      //E经度
      let lo = ToDegrees(item);
      return lo[0] + "°" + lo[1] + "′" + lo[2] + "′′" + "E";
    },
    getla(item) {
      //N纬度
      let la = ToDegrees(item);
      return la[0] + "°" + la[1] + "′" + la[2] + "′′" + "N";
    },
    initMap() {
      var host = "https://www.jacloud.net";
      var port1 = 468;
      var port2 = 469;

      const CRS_4490 = new L.Proj.CRS(
        "EPSG:4490",
        "+proj=longlat +ellps=GRS80 +no_defs",
        {
          resolutions: [
            1.40625, 0.703125, 0.3515625, 0.17578125, 0.087890625, 0.0439453125,
            0.02197265625, 0.010986328125, 0.0054931640625, 0.00274658203125,
            0.001373291015625, 6.866455078125e-4, 3.4332275390625e-4,
            1.71661376953125e-4, 8.58306884765625e-5, 4.291534423828125e-5,
            2.1457672119140625e-5, 1.0728836059570312e-5, 5.364418029785156e-6,
            2.682209064925356e-6, 1.3411045324626732e-6,
          ],
          origin: [-180, 90],
        }
      );
      //定义map变量，调用 L.map() 构造函数创建地图

      let baseMap = new L.tileLayer(
        `${host}:${port1}/ime-cloud/rest/quanguoyingxiang/dtile?request=GetTile&service=wmts&tilematrixSet=db200w&tileMatrix={z}&tilerow={y}&tilecol={x}`,
        { pane: "ypane" }
      );

      let hunanCom = new L.tileLayer(
        `${host}:${port1}/ime-cloud/rest/hn_tdt_6_14/dtile?request=GetTile&service=wmts&tilematrixSet=db200w&tileMatrix={z}&tilerow={y}&tilecol={x}`,
        { pane: "ypane0" }
      );

      let hunanHD = new L.tileLayer(
        `${host}:${port1}/ime-cloud/rest/thyx1_19/dtile?request=GetTile&service=wmts&tilematrixSet=db200w&tileMatrix={z}&tilerow={y}&tilecol={x}`,
        { pane: "ypane0" }
      );

      var baseMapLabel = new L.tileLayer(
        `${host}:${port2}/mapserver/label/WMTS/1.0/QGXZQHZJ/QGXZQHZJ?request=GetTile&service=wmts&tilematrixSet=db200w&tileMatrix={z}&tilerow={y}&tilecol={x}`,
        { pane: "ypane1" }
      );
      var baseMapBorder = new L.tileLayer(
        `${host}:${port2}/mapserver/vmap/WMTS/1.0/QGXZQHZJ/QGXZQHZJ?request=GetTile&service=wmts&tilematrixSet=db200w&tileMatrix={z}&tilerow={y}&tilecol={x}`,
        { pane: "ypane1" }
      );
      var hunanvMap = new L.tileLayer(
        `${host}:${port2}/mapserver/vmap/WMTS/1.0/dzdt2021/ff?request=GetTile&service=wmts&tilematrixSet=db200w&tileMatrix={z}&tilerow={y}&tilecol={x}`,
        { pane: "ypane1" }
      );
      var hunanLabel = new L.tileLayer(
        `${host}:${port2}/mapserver/label/WMTS/1.0/dzdt2021/ff?request=GetTile&service=wmts&tilematrixSet=db200w&tileMatrix={z}&tilerow={y}&tilecol={x}`,
        { pane: "ypane2" }
      );

      var hunanBorder = L.tileLayer(
        `${host}:${port2}/mapserver/vmap/WMTS/1.0/hnsxzh/hnsxzh?request=GetTile&service=wmts&tilematrixSet=db200w&tileMatrix={z}&tilerow={y}&tilecol={x}`,
        { pane: "ypane1" }
      );

      baseMap.setOpacity(0.8);
      hunanCom.setOpacity(0.8);
      var map;

      if (this.mapSwitch === 2) {
        map = L.map("map", {
          center: [27.63568754431514, 111.796875],
          zoom: 7,
          wheelPxPerZoomLevel: 2000,
          minZoom: 3,
          maxZoom: 12,
          // maxZoom: 11,
          crs: CRS_4490,
          zoomControl: false,
          attributionControl: false,
          // renderer: canvasLabel,
        });

        map.createPane("ypane");
        map.getPane("ypane").style.zIndex = 5;
        map.createPane("ypane0");
        map.getPane("ypane0").style.zIndex = 6;
        map.createPane("ypane1");
        map.getPane("ypane1").style.zIndex = 7; //行政图
        map.createPane("ypane2");
        map.getPane("ypane2").style.zIndex = 8; //行政图

        this.baseMap = L.layerGroup([
          baseMap,
          baseMapBorder,
          baseMapLabel,
          hunanBorder,

          hunanLabel,
        ]).addTo(map);

        map.off("zoomend");
        map.on("zoomend", (e) => {
          let zoom = map.getZoom();

          if (13 >= zoom && zoom > 8) {
            if (map.hasLayer(this.baseMap)) {
              map.removeLayer(this.baseMap);
            }

            this.baseMap = L.layerGroup([
              baseMap,
              hunanCom,
              baseMapBorder,
              baseMapLabel,
              hunanBorder,

              hunanLabel,
              hunanvMap,
            ]).addTo(map);
          } else if (zoom > 13) {
            if (map.hasLayer(this.baseMap)) {
              map.removeLayer(this.baseMap);
            }

            this.baseMap = L.layerGroup([
              baseMap,
              hunanHD,
              baseMapBorder,
              baseMapLabel,
              hunanBorder,

              hunanLabel,
              hunanvMap,
            ]).addTo(map);
          } else {
            if (map.hasLayer(this.baseMap)) {
              map.removeLayer(this.baseMap);
            }

            this.baseMap = L.layerGroup([
              baseMap,
              baseMapBorder,
              baseMapLabel,
              hunanBorder,

              hunanLabel,
            ]).addTo(map);
          }
        });

        L.mask({
          pane: "mask",
          color: "#000",
          fillOpacity: 0.2,
          renderer: L.canvas({ padding: 1 }), //解决遮罩层拖拽与缩放显示不全的Bug
        }).addTo(map);
      } else if (this.mapSwitch === 1) {
        map = L.map("map", {
          center: [27.63568754431514, 111.796875],
          zoom: 7,
          wheelPxPerZoomLevel: 2000,
          minZoom: 3,
          maxZoom: 12,
          zoomControl: false,
          attributionControl: false,
          // renderer: canvasLabel,
        });

        L.tileLayer
          .chinaProvider("Geoq.Normal.PurplishBlue", {
            maxZoom: 18,
            minZoom: 5,
          })
          .setOpacity(0.8)
          .addTo(map);

        L.mask({
          pane: "mask",
          color: "#fff",
          fillOpacity: 0.03,
          renderer: L.canvas({ padding: 1 }), //解决遮罩层拖拽与缩放显示不全的Bug
        }).addTo(map);
      } else if (this.mapSwitch === 0) {
        map = L.map("map", {
          center: [27.63568754431514, 111.796875],
          zoom: 7,
          wheelPxPerZoomLevel: 2000,
          minZoom: 3,
          maxZoom: 12,
          zoomControl: false,
          attributionControl: false,
          // renderer: canvasLabel,
        });

        L.tileLayer
          .chinaProvider("TianDiTu.Satellite.Map", {
            maxZoom: 18,
            minZoom: 5,
          })
          .setOpacity(0.9)
          .addTo(map);
        L.tileLayer
          .chinaProvider("TianDiTu.Satellite.Annotion", {
            maxZoom: 18,
            minZoom: 5,
          })
          .setOpacity(0.9)
          .addTo(map);

        L.mask({
          pane: "mask",
          color: "#000",
          fillOpacity: 0.48,
          renderer: L.canvas({ padding: 1 }), //解决遮罩层拖拽与缩放显示不全的Bug
        }).addTo(map);
      }

      map.createPane("airRoute");
      map.getPane("airRoute").style.zIndex = 300; //航路

      map.createPane("lineRoute");
      map.getPane("lineRoute").style.zIndex = 303;

      map.createPane("myoverlay");
      map.getPane("myoverlay").style.zIndex = 401;

      map.createPane("mask");
      map.getPane("mask").style.zIndex = 402; //遮罩层

      map.createPane("radar");
      map.getPane("radar").style.zIndex = 403; //色斑窗格，雷达图片窗格，气象窗格。

      map.createPane("provinceAndCityInfo");
      map.getPane("provinceAndCityInfo").style.zIndex = 404; //省界地图

      map.createPane("t_plane");
      map.getPane("t_plane").style.zIndex = 10000; //线 无事件放最下面

      map.createPane("poly");
      map.getPane("poly").style.zIndex = 10003; //面

      map.createPane("util");
      map.getPane("util").style.zIndex = 10010; //点工具类

      map.createPane("airport");
      map.getPane("airport").style.zIndex = 10006; //起降点

      map.createPane("adsb_base");
      map.getPane("adsb_base").style.zIndex = 10006; //基站

      map.createPane("dash");
      map.getPane("dash").style.zIndex = 10006; //航路点

      map.createPane("otherHight_air");
      map.getPane("otherHight_air").style.zIndex = 10007; //其他高度飞机

      map.createPane("adsb_air");
      map.getPane("adsb_air").style.zIndex = 10008; //当前高度飞机位置

      // 暴露map实例
      window.map = map;

      this.initDarwMapData();
      this.initMeteorologicalMapData();
      this.initplanreleMapData();

      //省界
      this.openboundaries();
      // this.demo();//雷达图

      // map.on("baselayerchange", function (layer) {
      //   let center = map.getCenter();
      //   let zoom = map.getZoom();
      //   console.log(map.options.crs);
      //   map.options.crs = CRS_4490;
      //   map.options.tms = false;
      //   map._resetView(center, zoom, true);
      // });
    },

    openboundaries() {
      var _this = this;

      function loadProvinceInfo() {
        var xhr = new XMLHttpRequest();

        xhr.open("GET", "/static/json/Hunan.json", false);

        xhr.onload = function (res) {
          var featuresInfo = JSON.parse(res.currentTarget.response);

          for (var p = 0; p < featuresInfo.features.length; p++) {
            var polygonFeature = featuresInfo.features[p];

            for (
              var j = 0;
              j < polygonFeature.geometry.coordinates.length;
              j++
            ) {
              for (
                var k = 0;
                k < polygonFeature.geometry.coordinates[j].length;
                k++
              ) {
                var f1 = polygonFeature.geometry.coordinates[j][k][0];
                var f2 = polygonFeature.geometry.coordinates[j][k][1];

                polygonFeature.geometry.coordinates[j][k][1] = f1 - 0;
                polygonFeature.geometry.coordinates[j][k][0] = f2 - 0;
              }
            }

            if (polygonFeature.properties.name == "湖南") {
              L.polygon(polygonFeature.geometry.coordinates[0], {
                pane: "provinceAndCityInfo",
                weight: 3,
                color: "#fff",
                opacity: 0.7,
                fillColor: "rgba(245,250,250,0.3)",
              }).addTo(map);
            }
          }
        };

        xhr.send();
      }
      loadProvinceInfo();
    },

    demo() {
      const CRS_4490 = new L.Proj.CRS(
        "EPSG:4490",
        "+proj=longlat +ellps=GRS80 +no_defs",
        {
          resolutions: [
            1.40625, 0.703125, 0.3515625, 0.17578125, 0.087890625, 0.0439453125,
            0.02197265625, 0.010986328125, 0.0054931640625, 0.00274658203125,
            0.001373291015625, 6.866455078125e-4, 3.4332275390625e-4,
            1.71661376953125e-4, 8.58306884765625e-5, 4.291534423828125e-5,
            2.1457672119140625e-5, 1.0728836059570312e-5, 5.364418029785156e-6,
            2.682209064925356e-6, 1.3411045324626732e-6,
          ],
          origin: [-180, 90],
        }
      );
      console.log(CRS_4490);
      var ofs4 = fragmentShaders["dbz"];
      var colorMap = getColorRamp(glColor.dbz);
      var xhr = new XMLHttpRequest();
      xhr.open("GET", "/static/0f4599e0-aeb9-430c-b805-fe5c20e2703b.png", true);
      xhr.responseType = "blob";
      var imgsrc;
      xhr.onload = (res) => {
        var blob = res.currentTarget.response;
        imgsrc = window.URL.createObjectURL(blob);

        L.imageOverlay
          .arrugator([imgsrc], {
            controlPoints: [
              [73.0, 12.21], // bottom-left
              [73.0, 54.2], // top-left
              [134.99, 12.21], // lower-right
              [134.99, 54.2], // upper-right
            ],
            projector: proj4("EPSG:4490", "EPSG:3857").forward,
            pane: "radar",
            epsilon: 1000000,

            colorMap: colorMap,
            fragmentShader: ofs4,
          })
          .addTo(map);
      };
      xhr.send();
    },
  },
  watch: {},
  mounted() {
    //初始化地图
    this.initMap();

    this.$eventBus.$off("initMap");
    this.$eventBus.$on("initMap", (baseMap) => {
      this.initMap(baseMap);
    });
  },
};
</script>

<style lang="less" scoped>
#map {
  background-color: var(--map-bg);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
}

.latlngDiv {
  display: flex;
  position: absolute;
  right: 10px;
  bottom: 85px;
  z-index: 3;
  color: #fff;
  font-size: 20px;

  span {
    margin: 0 10px;
    width: 180px;
  }
}
</style>